// extracted by mini-css-extract-plugin
export default {"tab":"SelectTab_tab__q0gTm","border":"SelectTab_border__K5dXE","tabItem":"SelectTab_tabItem__Okm1D","selected":"SelectTab_selected__vUGB6","disabled":"SelectTab_disabled__xOmTL"};